<template>
  <v-dialog :value="value" max-width="560" @input="$emit('input', $event)">
    <v-card class="rounded-lg">
      <div class="d-flex align-start pa-4 pb-2">
        <div class="flex-grow-1">
          <div class="text-overline grey--text text--darken-1">Certidão de Participação</div>
          <div class="text-h6 font-weight-bold">Emissão indisponível</div>
        </div>
        <v-btn icon aria-label="Fechar o aviso" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <v-card-text class="text-body-1" tabindex="0">
        Você não participou da fase de revisão, por isso não é possível emitir esta certidão.
        <template v-if="$modules.isOpen('site.review.create.creditor')">
          Para que seja possível, cadastre seu pedido de Revisão de Crédito
          <a href="/#/revisao-credito/novo" @click="$emit('input', false)"><strong>aqui</strong></a>,
          aguarde a análise e, quando concluída, tente novamente a emissão.
        </template>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn color="primary" elevation="0" aria-label="Fechar o aviso" @click="$emit('input', false)">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Aviso exibido quando o credor tenta emitir a Certidão de Participação sem ter apresentado Revisão de Crédito.
export default {
  name: 'CertificateReviewRequiredDialog',
  props: {
    value: { type: Boolean, default: false },
  },
};
</script>
